var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomePlant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 195,
    viewBox: "0 0 224 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 155.427L52.8651 189.578C52.6938 190.536 52.1896 191.404 51.4406 192.029C50.6916 192.654 49.7458 192.997 48.7687 192.997H16.7584C15.7723 192.995 14.8189 192.644 14.0673 192.008C13.3164 191.371 12.816 190.49 12.6556 189.52L7 155.427H59Z",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9874 151.326C64.9064 152.442 64.4378 153.484 63.6762 154.244C62.9146 155.004 61.9155 155.426 60.8785 155.426H6.12114C5.09614 155.426 4.10787 155.014 3.34941 154.269C2.59031 153.525 2.11612 152.503 2.01863 151.401C1.96418 150.784 2.02937 150.161 2.21044 149.573C2.39151 148.985 2.6853 148.444 3.0715 147.985C3.45769 147.526 3.92808 147.16 4.45356 146.909C4.97904 146.658 5.54691 146.528 6.12114 146.528H60.8785C61.447 146.528 62.0092 146.655 62.5303 146.901C63.0507 147.147 63.5192 147.506 63.9048 147.957C64.291 148.408 64.586 148.939 64.7721 149.52C64.9589 150.099 65.0317 150.714 64.9874 151.326Z",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7678 146.528C34.7678 144.79 39.2371 123.14 35.5276 103.974C33.5037 93.4489 29.0216 83.6637 20 78.3096",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 105.004C36 105.004 36.9656 90.2059 49 89.1855",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37 126.755C40.5061 123.971 44.7271 122.589 49 122.826",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37 116.868C37 116.868 27.7638 105.314 13 114.455",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30 112.064C30 112.064 9.93846 92.2312 6 119.047C6 119.047 11.6492 123.042 19.9877 119.047C28.3261 115.053 30 112.064 30 112.064Z",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0132 93.1269C40.0132 93.1269 39.2512 85.2451 49.2937 82.663C59.3362 80.0808 65 90.8977 65 90.8977C65 90.8977 57.2631 98.6618 40.0132 93.1269Z",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.001 123.363C43.001 123.363 42.6711 115.462 53.9266 117.089C65.1822 118.716 67 127.714 67 127.714C67 127.714 48.5665 134.047 43.001 124.215",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28 87.0453C28 87.6766 19.5929 86.2751 19.0547 86.1172C14.9842 84.8546 12.089 82.0009 10.1899 78.1876C9.57124 77.007 6.21211 70.3843 7.17098 69.2289C7.17098 69.2289 27.1958 62.6567 28 87.0453Z",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110 131.958C112.049 136.294 114.543 140.314 116.721 142.574C116.962 142.493 117.2 142.4 117.432 142.293C124.637 139.461 130.128 133.497 131.714 126.733C133.029 121.113 131.834 115.079 134.367 109.797C137.453 103.305 145.866 99.2417 146.891 91.9191C147.864 85.0892 141.996 78.8001 142.952 72.0757L143.072 71.3896",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113 74.3579C115.484 71.7769 118.368 69.3836 120.364 66.4969C125.95 58.4568 123.802 48.1545 127.391 39.3546C131.752 28.5719 145.505 21.069 159 22.0429C157.715 27.1762 156.843 32.4011 156.391 37.6688C155.997 42.3898 156.946 47.6479 155.899 52.2117C155.41 54.0883 154.552 55.8522 153.375 57.4043C145.274 62.2912 143.886 71.5716 143.886 71.5716",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M116 148.507C116.23 146.512 116.5 144.285 116.801 141.861C119.346 121.944 124.648 89.0923 134.341 61.9905L138.262 51.9269C141.693 43.8847 145.596 36.6608 150 30.8545",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M135 156.418L129.462 189.671C129.332 190.582 128.888 191.416 128.21 192.025C127.532 192.635 126.664 192.98 125.759 192.999H96.8182C95.9044 192.98 95.0278 192.628 94.3473 192.008C93.6663 191.387 93.2267 190.54 93.1073 189.618L88 156.418H135Z",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M141.977 152.781C141.924 153.745 141.492 154.655 140.767 155.329C140.043 156.003 139.078 156.391 138.067 156.415H85.9249C84.9241 156.393 83.9679 156.013 83.2452 155.352C82.5224 154.69 82.0849 153.795 82.0189 152.841C81.7939 150.516 83.6074 148.506 85.9249 148.506H138.049C138.608 148.519 139.159 148.642 139.666 148.869C140.173 149.095 140.625 149.42 140.994 149.821C141.363 150.223 141.641 150.693 141.811 151.203C141.98 151.712 142.037 152.249 141.977 152.781Z",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96 92.6783C99.2339 110.647 101.39 127.684 102.769 140.252V140.278L103.496 140.597C105.293 138.476 107.229 135.1 109.016 131.272C110.891 127.243 112.393 123.06 113.508 118.773C115.129 112.289 112.282 105.604 111.621 98.9625C111.372 95.7054 111.427 92.4331 111.788 89.1855",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104 148.506C103.449 146.138 102.764 143.47 102 140.597",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71 12.0703C82.864 30.9463 90.8333 62.8052 96 92.1533",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M99 53.0476C99 53.0476 100.422 26.9012 112.341 18.9533C124.26 11.0054 124 55.5737 124 55.5737",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M112.548 74.358C112.548 74.358 110.619 58.8958 114 43.709",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M111.651 89.3014C111.757 87.9068 111.894 86.5165 112 85.1219C112 82.1228 111.973 77.917 111.947 73.5232C111.65 71.5887 111.08 69.7053 110.254 67.9272C107.761 62.6504 102.903 58.8862 99.9898 53.8235C94.6279 44.5027 96.6878 32.5718 93.262 22.3459C89.0759 9.85109 75.9296 1.13356 63 2.28337C64.2384 8.26236 65.0743 14.3165 65.5019 20.4048C65.8821 25.8653 64.9626 31.9597 65.9793 37.2628C67.6149 45.7924 76.3893 50.9643 77.4723 59.7212C78.4227 67.4507 72.6099 74.6949 73.5603 82.5555C74.4002 89.4631 80.129 93.8569 83.8642 99.3217C84.7055 100.522 85.418 101.805 85.9905 103.152C88.4836 109.233 87.3166 116.197 88.6029 122.637C90.1721 130.445 95.6181 137.327 102.748 140.597V140.57C101.422 127.953 99.2693 110.842 96.0866 92.812",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M189.895 111.213C188.281 109.943 186.405 108.744 185.111 107.326C181.474 103.333 182.872 98.2354 180.542 93.8573C177.704 88.5139 168.774 84.7837 160 85.2748C160.834 87.7954 161.404 90.393 161.7 93.0274C161.958 95.3647 161.337 97.9729 162.019 100.225C163.14 103.875 169.098 106.085 169.823 109.828C170.461 113.139 166.518 116.234 167.17 119.601C167.864 123.217 173.52 125.211 175.603 128.407C177.298 131.007 176.5 133.98 177.385 136.744C178.45 140.081 182.13 143.028 186.996 144.417L187.47 144.552C188.941 143.43 190.62 141.457 192 139.327",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M165 88.1982C177.992 101.534 184.1 129.66 186.477 144.164C186.674 145.389 186.85 146.51 187 147.519",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M164 156.418L170.128 189.67C170.3 190.602 170.804 191.447 171.553 192.055C172.301 192.664 173.246 192.998 174.223 192.999H206.256C207.243 192.999 208.196 192.66 208.948 192.04C209.7 191.421 210.2 190.563 210.359 189.618L216 156.418H164Z",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M159.013 152.326C159.094 153.44 159.549 154.478 160.286 155.236C161.023 155.994 161.989 156.415 162.991 156.416H216.011C217.004 156.416 217.961 156.004 218.695 155.26C219.429 154.515 219.888 153.493 219.981 152.392C220.035 151.775 219.972 151.152 219.797 150.564C219.622 149.976 219.338 149.435 218.964 148.976C218.591 148.517 218.135 148.15 217.626 147.899C217.118 147.648 216.568 147.518 216.011 147.518H162.991C162.44 147.518 161.895 147.646 161.39 147.893C160.885 148.14 160.432 148.5 160.058 148.952C159.684 149.403 159.399 149.936 159.219 150.517C159.039 151.098 158.969 151.714 159.013 152.326Z",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M194.934 143.564C192.545 141.398 189.624 136.573 188.323 132.634C187.257 129.385 189.133 126.043 189.567 122.709C190.239 117.491 187.399 111.881 190.39 107.153C192.058 104.519 195.306 102.643 197.252 100.115C200.836 95.4641 199.465 89.5129 201.752 84.4143C204.558 78.1732 213.345 73.8249 222 74.409C221.173 77.3696 220.612 80.3934 220.323 83.4466C220.066 86.175 220.686 89.2145 220.004 91.8576C218.907 96.1206 213.04 98.6785 212.323 103.065C211.686 106.902 215.571 110.534 214.934 114.46C214.248 118.676 208.682 121.004 206.624 124.734C204.951 127.765 205.739 131.24 204.854 134.458C203.783 138.474 199.934 142.004 194.934 143.564Z",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M217 78.3105C204.611 93.8446 198.782 126.599 196.506 143.508C196.315 144.973 196.136 146.317 196 147.518",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M198 99.7857C198 99.7857 197.092 86.7109 189.464 82.7389C181.837 78.7669 182 101.05 182 101.05",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M190.9 109.949C190.9 109.949 194.767 102.473 188 95.1191",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePlant);
export default __webpack_public_path__ + "static/media/home_plant.975fdf833d9b09211a8394238135e938.svg";
export { ForwardRef as ReactComponent };